declare global {
  interface Window {
    gtag: (command: string, ...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}

function gtag(...args: unknown[]): void {
  if (typeof window.gtag !== 'function') return;
  window.gtag(...(args as [string, ...unknown[]]));
}

export function trackEvent(eventName: string, params?: Record<string, unknown>): void {
  gtag('event', eventName, params ?? {});
}

/** Kliknięcie w marker wydarzenia na mapie */
export const trackMarkerClick = () =>
  trackEvent('marker_click');

/** Zgłoszenie nowego wydarzenia */
export const trackEventSubmission = (userType: 'user' | 'mod_admin') =>
  trackEvent('event_submission', { user_type: userType });

/** Zapisano edycję istniejącego wydarzenia */
export const trackEventEdit = () =>
  trackEvent('event_edit');

/** Otwarto popup Kontakt */
export const trackContactOpen = () =>
  trackEvent('contact_open');

/** Dodano nowego użytkownika */
export const trackAddUser = () =>
  trackEvent('add_user');

// ─── Search ───────────────────────────────────────────────────────────────────

/** Wyszukanie frazy (≥3 znaki, po debounce) */
export const trackPhraseSearch = (phrase: string, resultCount: number) =>
  trackEvent('phrase_search', { search_term: phrase, result_count: resultCount });

/** Zastosowanie filtra dat */
export const trackDateFilter = (startDate: string | null, endDate: string | null) =>
  trackEvent('date_filter_applied', { start_date: startDate ?? 'none', end_date: endDate ?? 'none' });

/** Zastosowanie filtra tagów */
export const trackTagFilter = (tag: string) =>
  trackEvent('tag_filter_applied', { tag });

// ─── Map interactions ─────────────────────────────────────────────────────────

/** Otwarcie popupu wydarzenia na mapie */
export const trackEventPopupOpen = (eventId: string, eventTitle?: string) =>
  trackEvent('event_popup_open', { event_id: eventId, event_title: eventTitle ?? '' });

/** Kliknięcie "Jak dojść" w popupie */
export const trackDirectionsClick = (eventId: string) =>
  trackEvent('directions_click', { event_id: eventId });

/** Użycie przycisku "W pobliżu" */
export const trackNearMeClick = () =>
  trackEvent('near_me_click');

// ─── Event management ────────────────────────────────────────────────────────

/** Dodanie nowego wydarzenia */
export const trackEventAdded = (source: 'mod_admin' | 'user') =>
  trackEvent('event_added', { source });

/** Usunięcie wydarzenia */
export const trackEventDeleted = (eventId?: string) =>
  trackEvent('event_deleted', { event_id: eventId ?? '' });

// ─── Submissions ─────────────────────────────────────────────────────────────

/** Zatwierdzenie zgłoszenia przez moderatora */
export const trackSubmissionApproved = () =>
  trackEvent('submission_approved');

/** Odrzucenie zgłoszenia przez moderatora */
export const trackSubmissionRejected = () =>
  trackEvent('submission_rejected');

/** Edycja zgłoszenia przez moderatora */
export const trackSubmissionEdited = () =>
  trackEvent('submission_edited');

/** Usunięcie zgłoszenia */
export const trackSubmissionDeleted = () =>
  trackEvent('submission_deleted');

// ─── Reports ─────────────────────────────────────────────────────────────────

/** Zgłoszenie nieprawidłowości przez użytkownika */
export const trackEventReported = (eventId: string) =>
  trackEvent('event_reported', { event_id: eventId });

// ─── Cookie consent ───────────────────────────────────────────────────────────

/** Użytkownik zaakceptował cookies */
export const trackCookieAccepted = () =>
  trackEvent('cookie_consent', { consent: 'accepted' });

/** Użytkownik odrzucił cookies */
export const trackCookieRejected = () =>
  trackEvent('cookie_consent', { consent: 'rejected' });

// ─── UI interactions ─────────────────────────────────────────────────────────

/** Otwarcie sidebara */
export const trackSidebarOpen = () =>
  trackEvent('sidebar_open');

/** Otwarcie modala "Dodaj wydarzenie" */
export const trackAddEventModalOpen = () =>
  trackEvent('add_event_modal_open');

/** Otwarcie polityki prywatności */
export const trackPrivacyPolicyOpen = () =>
  trackEvent('privacy_policy_open');

// ─── Social links ─────────────────────────────────────────────────────────────

/** Kliknięcie w link do Instagrama */
export const trackInstagramClick = () =>
  trackEvent('social_click', { platform: 'instagram' });

/** Kliknięcie w link do Discorda */
export const trackDiscordClick = () =>
  trackEvent('social_click', { platform: 'discord' });
